import Debug from "./Debug.vue";

export default [ 
    {
        path: '/debug',
        name: 'Debug',
        meta: {
            allowAnonymous: false, 
            title: 'Debug'
        },
        component: Debug
    }
];
